Vue.component('goal-element', {
  props: ['goal', 'is_active', 'index'],

  data() {
    return {
      timeProgress: 0
    }
  },

  computed: {
    cleanDueDate() {
      return date = moment(this.goal.achieve_by_date).format("D MMM YYYY")
    },
    cleanStartDate() {
      return date = moment(this.goal.start_date).format("D MMM YYYY")
    },
    percentProgress() {

      let percent = (this.goal.current_stats.no_of_reviews / this.goal.details.actual_needed_no_of_reviews) * 100
      return percent

    },
    timeProgressPercent() {
      return this.timeProgress
    },
    trackClass() {
      if (this.goal.current_status == 'on_target') {
        return 'badge-success'
      } else if (this.goal.current_status == 'achieved') {
        return 'badge-info'
      } else if (this.goal.current_status == 'off_target' || this.goal.current_status == 'way_off_target') {
        return 'badge-warning'
      } else if (this.goal.current_status == 'failed') {
        return 'badge-danger'
      }
      else {
        return 'badge-secondary'
      }
    },
    trackText() {
      let labels = {
        on_target: 'On Target',
        off_target: 'Off Target',
        way_off_target: 'Way Off Target',
        failed: 'Failed',
        achieved: 'Achieved'
      }

      return labels[this.goal.current_status]
    }
  },

  methods: {
    selectGoal() {
      this.$parent.$emit('selectGoal', this.index)
    },
    removeGoal() {
      swal({
        title: 'Are you sure you want to cancel this goal?',
        text: 'Cancelled goals will still be available in your dashboard',
        type: 'warning',
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        cancelButtonColor: "#DD6B55",
        confirmButtonColor: "#DD6B55",
      }, (result) => {
        if (result) {
          axios.delete('/api/goals/' + this.goal.team_id + '/' + this.goal.id)
            .then(response => {
              this.$eventHub.$emit('goalsUpdated', true)

              analytics.track("Goal Deleted", {
                team_id: this.goal.team_id
              })

            }).catch(error => {
              console.log(error)
            })
        }
      });
    }
  },

  mounted() {
    setTimeout(
        _ => {

          let percent = (this.goal.current_stats.number_of_days / this.goal.details.in_how_many_days) * 100
          if (percent > 99) percent = 99

          this.timeProgress = percent
        },
        2000
    )
  }

})